import pageType from 'Addons/search/pageType';
import type { PreselectionEntry } from 'Models/facetRequest';
import type { ConfigGetter } from 'Models/uiConfig/requestTypes';

type BreadcrumbPreselection = PreselectionEntry[];

type BreadcrumbGetterDefaults = {
  getter: (currentPageType: string) => BreadcrumbPreselection | undefined;
  readonly termFromBreadcrumbs: string;
};

type BreadcrumbGetter = ConfigGetter<
  [currentPageType: string],
  BreadcrumbPreselection | undefined,
  BreadcrumbGetterDefaults
> & { defaults: BreadcrumbGetterDefaults };

export function makeGetLocalPreselectionFromBreadcrumbs(
  breadcrumbsSelector: string,
  pageTypeToFieldMap: Record<string, string>,
  parseBreadcrumbs: (...elements: Element[]) => string[],
): BreadcrumbGetter {
  function getTermFromBreadcrumbs(): string {
    return parseBreadcrumbs(...window.document.querySelectorAll(breadcrumbsSelector)).join('>');
  }

  function getter(currentPageType: string): BreadcrumbPreselection | undefined {
    const field = pageTypeToFieldMap[currentPageType];
    const termFromBreadcrumbs = getTermFromBreadcrumbs();
    if (field && termFromBreadcrumbs) {
      const treeLevel =
        currentPageType === pageType.category ? termFromBreadcrumbs.split('>').length - 1 : null;
      return [{ field: pageTypeToFieldMap[currentPageType], term: termFromBreadcrumbs, treeLevel }];
    }
  }

  getter.defaults = {
    getter,
    get termFromBreadcrumbs() {
      return getTermFromBreadcrumbs();
    },
  };

  return getter;
}
